<template>
  <section class="pos-r">
    <div class="back">
      <div class="back__arrow" @click="$emit('back')" />
      <div class="back__title">Запись на погрузку</div>
    </div>
    <div class="wrapper">
      <div class="choice">
        <div class="choice__title">Выберите дату погрузки</div>
        <double-select
          title="Выберите дату погрузки"
          :list="days"
          @select-changed="dateChoosen"
        />
      </div>
      <div v-if="infoSources.length" class="choice">
        <div class="choice__title">Откуда узнали о погрузке</div>
        <double-select-info
          title="Выберите вариант"
          :list="infoSources"
          @select-changed="infoChoosen"
        />
      </div>
      <div class="buttons">
        <div class="button grey" @click="$emit('back')">Отмена</div>
        <div
          v-if="choosed_day !== null"
          class="button primary"
          @click="$emit('next', choosed_day, info_source_id)"
        >
          Далее
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DoubleSelect from '@/components/Drivers/DoubleSelect/DoubleSelect'
import DoubleSelectInfo from '@/components/Drivers/DoubleSelect/DoubleSelectInfo'
export default {
  name: 'ChooseDayMobile',
  components: { DoubleSelect, DoubleSelectInfo },
  props: {
    days: {
      type: Array,
      default: () => [],
    },
    infoSources: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      choosed_day: null,
      info_source_id: null,
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {
    dateChoosen(day) {
      this.choosed_day = day
    },
    infoChoosen(info) {
      this.info_source_id = info
    },
  },
}
</script>

<style lang="sass" scoped>
.pos-r
  position: relative
</style>
